import {
  H5,
  Modal,
  P,
  Separator,
  centsToDollars,
  formatter,
  PropsModal,
  StatusCircle,
  Div,
} from '@vgrubs/components';
import {
  NewTransactionResponse,
  vGrubsWithdrawalEntity,
} from 'components/src/types/api/wallet.types';
import { DateTime } from 'luxon';
import { TextWithTooltipIcon, showStatusColor } from '../TransactonsStyled';

export const WithdrawalDetailModal = ({
  modalIsOpen,
  closeModal,
}: PropsModal & {
  modalIsOpen: NewTransactionResponse<vGrubsWithdrawalEntity> | null;
}) => {
  const transaction = modalIsOpen?.object;

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      textAlign={'left'}
      header={'Withdrawal Details'}
    >
      <P $m="0">Date & Time</P>
      <H5 $m="0">
        {DateTime.fromISO(transaction?.createdAt || '').toFormat(
          'MMM dd, yyyy - hh:mm a'
        )}
      </H5>
      <Separator $m="16px 0" />
      <P $m="0">Description</P>
      <H5 $m="0">{transaction?.description}</H5>
      <Separator $m="16px 0" />
      <P $m="0">Status</P>
      <Div $flex $alignCenter $gap="8px">
        <StatusCircle $color={showStatusColor(transaction?.status || null)} />
        <H5 $m="0" $capitalize>
          {transaction?.status}
        </H5>
      </Div>

      <Separator $m="16px 0" />
      <P $m="0">Withdrawal amount</P>
      <H5 $m="0">
        {' '}
        {formatter.format(
          centsToDollars(
            (transaction?.amount || 0) -
              (transaction?.fee || 0) -
              (transaction?.failureFee || 0)
          )
        )}
      </H5>
      <Separator $m="16px 0" />
      <TextWithTooltipIcon
        text="Processing Fee"
        tooltip={
          'The processing fee you selected when withdrawing your funds in either "Minutes", "1 Day" or "Standard".'
        }
      />

      <H5 $m="0">{formatter.format(centsToDollars(transaction?.fee || 0))}</H5>

      {transaction?.failureFee && (
        <>
          <Separator $m="16px 0" />
          <TextWithTooltipIcon
            text="Previous Failure Fee"
            tooltip={
              'This fee was applied because your previous withdrawal attempt failed (usually due to an incorrect bank account number).'
            }
          />
          <H5 $m="0">
            {formatter.format(centsToDollars(transaction?.failureFee || 0))}
          </H5>
        </>
      )}

      <Separator $m="16px 0" />
      <P $m="0">Total</P>
      <H5 $m="0">
        {formatter.format(centsToDollars(transaction?.amount || 0))}
      </H5>
    </Modal>
  );
};
